import useMutationApi from '../useMutationApi';
import type {
  CheckOverlapResponse,
  OverlappingRebateTransactionRecord,
} from '@erp/shared-types';

interface CheckOverlapRequest {
  supplierId: string;
  startDate: string; // YYYY-MM-DD format
  endDate: string; // YYYY-MM-DD format
}

/**
 * Hook to check for overlapping invoices before submission
 *
 * Usage:
 * ```tsx
 * const { mutateAsync: checkOverlap, isPending } = useCheckOverlap();
 *
 * const result = await checkOverlap({
 *   supplierId: 'uuid',
 *   startDate: '2025-01-01',
 *   endDate: '2025-03-31'
 * });
 *
 * if (result.data.hasOverlap) {
 *   // Show overlap modal
 * }
 * ```
 */
function useCheckOverlap() {
  return useMutationApi<CheckOverlapRequest, CheckOverlapResponse>({
    endpoint: 'spreadsheet/csv/check-overlap',
    method: 'POST',
    showSuccessToast: false, // Silent operation - no need to show success
    showErrorToast: true,
  });
}

export { useCheckOverlap };

// Re-export types for convenience
export type {
  CheckOverlapRequest,
  CheckOverlapResponse,
  OverlappingRebateTransactionRecord,
};
